/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import './CSS/NewDashboard.css';
import { connect } from 'react-redux';
import 'react-grid-layout/css/styles.css';
import { getDashboardByName } from './DashboardCalls';
import localstorage from '../../../utils/localStorage';
import DashboardLevelConfig from './DashboardLevelConfig';
import { Responsive, WidthProvider } from 'react-grid-layout';
import ConfigurationModalContent from './ConfigurationModalContent';
import { insertDashboard, updateDashboard } from './DashboardCalls';
import { Input, Button, message, Select, Modal, Form, Tooltip, Space, Checkbox } from 'antd';
import {
  Title,
  DashboardTheme,
  AddPanelBtn,
  PanelDiv,
  DeletePanelDiv,
  EditDashboardDiv,
  AddConfigurationDiv
} from '../CSS/style';
import {
  DownloadOutlined,
  PlusCircleOutlined,
  SaveOutlined,
  MinusCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';

const Option = Select.Option;
const ResponsiveReactGridLayout = WidthProvider(Responsive);

const NewDashboard = (props) => {
  const [deviceMultiSelect, setDeviceMultiSelect] = useState("false");
  const [panels, setPanels] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editData, setEditData] = useState([]);
  const [dashboardName, setDashboardName] = useState('');
  const [imageName, setImageName] = useState('');
  const [id, setId] = useState('');
  const [mode, setMode] = useState('insert');
  const [dashboardType, setDashboardType] = useState('static');
  const [DashboardLevelSelection, setDashboardLevelSelection] = useState('none');
  const [TimeBucket, setTimeBucket] = useState('none');
  const [treeExists, setTreeExists] = useState('false');
  const [apiPayload, setApiPayload] = useState({});
  const [treePayload, setTreePayload] = useState({});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [hierarchyLevels, setHierarchyLevels] = useState([]);
  const [GroupName, setGroupName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [DashboardLevelSelectionPoint, setDashboardLevelSelectionPoint] = useState('PreviousDay');
  const [inputFields, setInputFields] = useState({
    Day: '',
    Week: '',
    Month: '',
    Year: ''
  });
  const [TimeBucketKey, setTimeBucketKey] = useState(true);
  const [checkedList, setCheckedList] = useState(false);
  const [apiPayloadData, setApiPayloadData] = useState({});
  const [apiPayloadCount, setApiPayloadCount] = useState({});
  const [apiPayloadDeviceSelection, setApiPayloadDeviceSelection] = useState({});
  const [hierarchyViewType, setHierarchyViewType] = useState('');
  const [isMultiLevelDashboard, setIsMultiLevelDashboard] = useState(false);
  const [multiLevelSettings, setMultiLevelSettings] = useState([]);
  const [dashboardId, setDashboardId] = useState(undefined);
  const [isChildren, setIsChildren] = useState(false);

  useEffect(() => {
    const siteId = localstorage.get('currentSite');
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
      setHierarchyLevels(
        props.userProfile && props.userProfile.belongsTo && props.userProfile.belongsTo.sites[siteId]
          ? props.userProfile.belongsTo.sites[siteId].hierarchy
          : hierarchyLevels
      );
    }
  }, [props.userProfile]);

  useEffect(() => {
    const dashboardName = props.location;
    if (dashboardName && dashboardName.state && dashboardName.state !== 'new') {
      getDashboardDataName(dashboardName.state);
    }
  }, [props.location]);

  const getDashboardDataName = async (dashboardName) => {
    let dashboardObject = await getDashboardByName(dashboardName);
    let dashboardData = dashboardObject && dashboardObject[0] ? dashboardObject[0] : {};
    let headerJSON = dashboardData && dashboardData.headerJSON ? dashboardData.headerJSON : {};
    setMode('update');
    setDashboardName(dashboardData && dashboardData.Name ? dashboardData.Name : '');
    setDashboardId(dashboardData && dashboardData.Id ? dashboardData.Id : ''),
      setIsChildren(headerJSON && headerJSON.isChildren ? headerJSON.isChildren : false);
    setDashboardType(headerJSON && headerJSON.dashboardType ? headerJSON.dashboardType : 'static');
    setHierarchyViewType(headerJSON && headerJSON.hierarchyViewType ? headerJSON.hierarchyViewType : hierarchyViewType);
    setIsMultiLevelDashboard(headerJSON && headerJSON.isMultiLevelDashboard ? headerJSON.isMultiLevelDashboard : isMultiLevelDashboard);
    setMultiLevelSettings(headerJSON && headerJSON.multiLevelSettings ? headerJSON.multiLevelSettings : multiLevelSettings);
    setPanels(dashboardData && dashboardData.json ? dashboardData.json : []);
    setGroupName(dashboardData && dashboardData.GroupName ? dashboardData.GroupName : '');
    setDashboardLevelSelection(headerJSON && headerJSON.DashboardLevelSelection ? headerJSON.DashboardLevelSelection : 'none');
    setTimeBucket(headerJSON && headerJSON.TimeBucket ? headerJSON.TimeBucket : 'none');
    setDashboardLevelSelectionPoint(headerJSON && headerJSON.DashboardLevelSelectionPoint ? headerJSON.DashboardLevelSelectionPoint : 'PreviousDay');
    setInputFields(headerJSON && headerJSON.TimeBucket && headerJSON.DashboardLevelSelection === 'dateMonthYearPicker' ? headerJSON.TimeBucket : {});
    setTreeExists(headerJSON && headerJSON.treeExists ? headerJSON.treeExists : 'false');
    setApiPayload(headerJSON && headerJSON.apiPayload ? headerJSON.apiPayload : {});
    setTreePayload(headerJSON && headerJSON.treePayload ? headerJSON.treePayload : {});
    setImageName(headerJSON && headerJSON.imageName ? headerJSON.imageName : '' );
    setCheckedList(headerJSON && headerJSON.checkedList ? headerJSON.checkedList : false);
    setApiPayloadData(dashboardData && dashboardData.json && dashboardData.json[0] && dashboardData.json[0].apiPayloadData ? dashboardData.json[0].apiPayloadData : {});
    setApiPayloadCount(dashboardData && dashboardData.json && dashboardData.json[0] && dashboardData.json[0].apiPayloadCount ? dashboardData.json[0].apiPayloadCount : {});
    setDeviceMultiSelect(headerJSON && headerJSON.deviceMultiSelect ?headerJSON.deviceMultiSelect :"false");
    setApiPayloadDeviceSelection(dashboardData && dashboardData.json && dashboardData.json[0] && dashboardData.json[0].apiPayloadDeviceSelection ?dashboardData.json[0].apiPayloadDeviceSelection :{});
  };

  const showModals = () => {
    setIsModalOpen(true);
  };

  const handleOks = () => {
    setIsModalOpen(false);
  };

  const handleCancels = () => {
    setIsModalOpen(false);
  };
  const enterURL = (e) => {
    const newApiPayload = {
      url: e.target.value,
      method: apiPayload.method ? apiPayload.method : '',
      ...(apiPayload.method === 'POST' ? { payload: apiPayload.payload } : {})
    };
    setApiPayload(newApiPayload);
  };

  const selectMethod = (value) => {
    const newApiPayload = {
      url: apiPayload.url || '',
      method: value,
      ...(apiPayload.method === 'POST' ? { payload: apiPayload.payload } : {})
    };
    setApiPayload(newApiPayload);
  };

  const selectPayload = (e) => {
    const newApiPayload = {
      url: apiPayload.url || '',
      method: apiPayload.method || '',
      payload: JSON.parse(e.target.value)
    };
    setApiPayload(newApiPayload);
  };

  const selectGETParams = (e) => {
    const newApiPayload = {
      url: apiPayload.url || '',
      method: apiPayload.method || '',
      GETParams: e.target.value
    };
    setApiPayload(newApiPayload);
  };

  // const enterTreeURL = (e) => {
  //   const newTreePayload = {
  //     url: e.target.value,
  //     method: treePayload.method ? treePayload.method : '',
  //     ...(treePayload.method === 'POST' ? { payload: treePayload.payload } : {})
  //   };
  //   setTreePayload(newTreePayload);
  // };

  // const selectTreeMethod = (value) => {
  //   const newTreePayload = {
  //     url: treePayload.url || '',
  //     method: value,
  //     ...(treePayload.method === 'POST' ? { payload: treePayload.payload } : {})
  //   };
  //   setTreePayload(newTreePayload);
  // };

  // const selectTreePayload = (e) => {
  //   const newTreePayload = {
  //     url: treePayload.url || '',
  //     method: treePayload.method || 'GET',
  //     payload: JSON.parse(e.target.value)
  //   };
  //   setTreePayload(newTreePayload);
  // };

  const handleRemoveFields = (keyName) => {
    const updatedInputFields = { ...inputFields };
    delete updatedInputFields[keyName];
    setInputFields(updatedInputFields);
  };

  // const selectTreeGETPayload = (e) => {
  //   setTreePayload((prevTreePayload) => ({
  //     ...prevTreePayload,
  //     GETParams: e.target.value,
  //   }));
  // };

  const handleInputChange = (event, item) => {
    const updatedInputFields = { ...inputFields, [item]: event.target.value };
    setInputFields(updatedInputFields);
  };

  const resetTimeBucket = () => {
    const TimeBucket = {
      Day: '',
      Week: '',
      Month: '',
      Year: '',
      ...inputFields,
    };
    setInputFields(TimeBucket);
  };


  const onChangeimageName=(e)=>{
  let data = e.target.value;
  setImageName(data);
  };

  // handleChangeFile = (e) => {
  //   let context = this;
  //   var reader = new FileReader();
  //   reader.readAsText(e[0]);
  //   reader.onloadend = function () {
  //     let fileData = JSON.parse(reader.result);
  //     context.setState({ panels: fileData.json });
  //   };
  // };

  // setTitle = (e) => {
  //   this.setState({ title: e.target.value, id: this.state.id });
  // };

  // redirect() {
  //   let { dashboardName } = this.state;
  //   this.props.navigate(
  //     dashboardName.length === 0 ? '/dashboard/' : '/dashboard/' + dashboardName
  //   );
  // }

  const addPanel = () => {
    const newPanel = {
      id: panels.length + 1,
      title: 'new panel',
      graph: 'guage',
      source: 'mqtt',
      query: '',
      query1: '',
      query2: '',
      position: { x: 0, y: 0, w: 4, h: 6 }
    };
    setPanels((prev) => [...prev, newPanel]);
  };


  const createPanels = () => {
    return (
      <ResponsiveReactGridLayout
        className="layout"
        draggableHandle=".headerdrag"
        onResizeStop={updatePosition}
        onDragStop={updatePosition}
        rowHeight={30}
      >
        {getPanels()}
      </ResponsiveReactGridLayout>
    );
  };


  const updatePosition = (data) => {
    const updatedPanels = panels.map((panel, index) => {
      const newPosition = data[index];
      return {
        ...panel,
        position: {
          ...panel.position,
          x: newPosition.x,
          y: newPosition.y,
          w: newPosition.w,
          h: newPosition.h,
        },
      };
    });
    setPanels(updatedPanels);
  };

  const getPanels = () => {
    return panels && Array.isArray(panels) && panels.map((value) => {
      const { x, y, w, h } = value.position;
      return (
        <PanelDiv
          key={value.id} // Use value.id for unique keys
          data-grid={{
            x,
            y,
            w,
            h,
            isResizable: true,
          }}
        >
          <div className="headerdrag">
            <Title>{value.title}</Title>
          </div>
          <AddConfigurationDiv>
            <Button type="primary" shape="round" onClick={() => editConfiguration(value)}>
              <PlusCircleOutlined />
              Edit Configuration
            </Button>
          </AddConfigurationDiv>
          <DeletePanelDiv>
            <Button type="primary" shape="round" onClick={() => deletePanel(value.id)}>
              <DownloadOutlined />
              Delete Panel
            </Button>
          </DeletePanelDiv>
        </PanelDiv>
      );
    });
  };

  const deletePanel = (id) => {
    // Filter out the panel with the specified id
    const updatedPanels = panels.filter(panel => panel.id !== id);

    // Reassign ids to maintain sequential order
    const renumberedPanels = updatedPanels && Array.isArray(updatedPanels) && updatedPanels.map((value, index) => ({
      ...value,
      id: index + 1 // Reassign id starting from 1
    }));

    setPanels(renumberedPanels);
  };

  const editConfiguration = (value) => {
    const editData = panels.filter((filterData) => value.id === filterData.id);
    setDeviceMultiSelect("true");
    setId(value.id);
    showModal(editData);
  };

  const showModal = (value) => {
    setVisible(true);
    setEditData(value);
  };

  const handleOk = (config) => {
    
    let updatedApiPayloadCount = {
      method: config?.apiPayloadCount?.method || '',
      url: config?.apiPayloadCount?.url || '',
      payload: config?.apiPayloadCount?.payload || {},
      GETParams: config?.apiPayloadCount?.GETParams || ''
    };

    let updatedApiPayloadData = {
      method: config?.apiPayloadData?.method || '',
      url: config?.apiPayloadData?.url || '',
      payload: config?.apiPayloadData?.payload || {},
      GETParams: config?.apiPayloadData?.GETParams || '',
    };

    let updatedApiPayloadDeviceSelection = {
      method: config?.apiPayloadDeviceSelection?.method || '',
      url: config?.apiPayloadDeviceSelection?.url || '',
      payload: config?.apiPayloadDeviceSelection?.payload || {},
      GETParams: config?.apiPayloadDeviceSelection?.GETParams || '',
    };

    try {
      let panelData = panels && Array.isArray(panels) && panels.map((value) => {
        if (value.id === id) {
          return {
            ...value,
            ...config,
            GraphLevelTimeBucket:
              value.GraphLevelSelection === 'dateMonthYearPicker'
                ? value.inputGraphFields
                : config.GraphLevelTimeBucket,
            ...updatedApiPayloadCount,
            ...updatedApiPayloadData,
            ...updatedApiPayloadDeviceSelection
          };
        }
        return value;
      });

      setPanels(panelData);
      setApiPayloadCount(updatedApiPayloadCount);
      setApiPayloadData(updatedApiPayloadData);
      setApiPayloadDeviceSelection(updatedApiPayloadDeviceSelection);
      setVisible(false);
      setId('');
    } catch (e) {
      message.error('Configuration Error!');
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const validateDashboardConfig = (json) => {
    if (!Array.isArray(json) || json.length > 6) {
      return false;
    }
    for (const obj of json) {
      if (obj.graph === "DashboardInDashboard") {
        return false;
      }
    }

    return true;
  };

  const saveDashboard = async () => {
    if (dashboardName.trim().length !== 0) {
      const updatedPanels = panels && Array.isArray(panels) && panels.map((value) => {
        if (value.queryData && Array.isArray(value.queryData) && value.queryData.length === 0) {
          delete value.query1;
        }
        return {
          ...value,
          dashboardName,
          apiPayloadData,
          apiPayloadCount,
          apiPayloadDeviceSelection,
        };
      });

      let headerJSON = {
        treeExists,
        DashboardLevelSelection,
        DashboardLevelSelectionPoint,
        TimeBucket:
          DashboardLevelSelection && DashboardLevelSelection === 'dateMonthYearPicker'
            ? inputFields
            : TimeBucket,
        dashboardType,
        hierarchyViewType,
        apiPayload,
        treePayload,
        checkedList,
        isChildren,
        deviceMultiSelect,
        imageName
      };
      
      let validationStatus = true;
      if (isChildren === true) {
        validationStatus = await validateDashboardConfig(updatedPanels);
      }

      try {
        let msg;
        if (validationStatus) {
          if (mode === 'insert') {
            msg = await insertDashboard(updatedPanels, dashboardName, dashboardId, GroupName, headerJSON);
            message.success(msg);
            setPanels([]);
            setVisible(false);
            setEditData([]);
            setDashboardName('');
            setImageName('');
            setMode('insert');
            setApiPayload({});
            setHierarchyViewType('');
            setCheckedList([]);
            setTreePayload({});
            setApiPayloadData({});
            setApiPayloadCount({});
            setApiPayloadDeviceSelection({});
            setIsChildren(false);
            // setDeviceMultiSelect("false");
          } else {
            msg = await updateDashboard(updatedPanels, dashboardName, dashboardId, GroupName, headerJSON);
            message.success(msg);
            setPanels([]);
            setVisible(false);
            setEditData([]);
            setDashboardName('');
            setImageName('');
            setMode('insert');
            setApiPayload({});
            setHierarchyViewType('');
            setCheckedList([]);
            setTreePayload({});
            setApiPayloadData({});
            setApiPayloadCount({});
            setApiPayloadDeviceSelection({});
            setIsChildren(false);
            // setDeviceMultiSelect("false");
          }
          props.navigate('/rubus/settingspage/dashboardConfiguration');
        } else {
          message.error("More than six panels are not allowed , No child dashboard to be configured inside child dashboard");
        }

      } catch (error) {
        message.error('Error saving dashboard: ' + error.message);
      }
    } else {
      console.log('Enter Dashboard Name');
    }
  };
  const checkboxOnChange = (value) => {
    if (value === "true") {
      setDeviceMultiSelect("true");
      // setIsModalOpen(true);
    } else {
      setDeviceMultiSelect("false");
    }
  };


  return (
    <EditDashboardDiv>
      <div style={{ padding: '10px', marginTop: '56px' }}>
        <Button
          style={{ float: 'right', marginLeft: '10px' }}
          type="primary"
          shape="round"
          onClick={saveDashboard}
        >
          <SaveOutlined />
          Save Dashboard
        </Button>
        <Input
          style={{ width: '150px', float: 'right', marginLeft: '10px' }}
          type="text"
          value={dashboardName}
          placeholder="Enter Dashboard Name"
          onChange={(e) => setDashboardName(e.target.value)}
        />
        <Input
          style={{ width: '150px', float: 'right' }}
          type="text"
          value={GroupName}
          placeholder="Enter Group Name"
          onChange={(e) => setGroupName(e.target.value)}
        />
        <AddPanelBtn type="primary" shape="round" onClick={addPanel}>
          <PlusCircleOutlined />
          Add Panel
        </AddPanelBtn>
        <div style={{ marginLeft: '10px', float: 'left' }}>
          <Button type="primary" shape="round" onClick={showModals}>
            <PlusCircleOutlined />
            Headers
          </Button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ color: 'white' }}>New dashboard creation</h3>
        </div>
      </div>
      <Modal
        title="Header Selection"
        style={{ height: 700 }}
        width={1000}
        open={isModalOpen}
        okText="Update"
        cancelText="Close"
        onOk={handleOks}
        onCancel={handleCancels}
      >
        <Form labelCol={{ span: 6 }} wrapperCol={{ span: 8 }}>
          <Form.Item label="Is Children">
            <Select
              onChange={(value) => {
                setIsChildren(value);
              }}
              value={isChildren}
            >
              <Option value={true}>true</Option>
              <Option value={false}>false</Option>
            </Select>
          </Form.Item>


          <Form.Item label="Selection Type">
            <DashboardTheme
              onChange={(value) => {
                let TimeBucket = 'none';
                if (value === 'datePicker' || value === 'dateRangePicker') {
                  TimeBucket = '1h';
                  setTimeBucketKey(false);
                } else if (value === 'monthPicker') {
                  TimeBucket = '1d';
                  setTimeBucketKey(false);
                } else if (value === 'none') {
                  setTimeBucketKey(true);
                  TimeBucket = '';
                } else {
                  TimeBucket = '';
                  setTimeBucketKey(true);
                }
                if (value === 'dateMonthYearPicker') {
                  setInputFields({ Day: '', Week: '', Month: '', Year: '' });
                  setDashboardLevelSelection(value);
                  setTimeBucket({ Day: '', Week: '', Month: '', Year: '' });
                } else {
                  setDashboardLevelSelection(value);
                  setTimeBucket(TimeBucket);
                }
              }}
              value={DashboardLevelSelection}
            >
              <Option value="datePicker">Date Selection</Option>
              <Option value="dateRangePicker">DateRange Selection</Option>
              <Option value="monthPicker">Month Selection</Option>
              <Option value="dateMonthYearPicker">DayMonthYear Selection</Option>
              {/* <Option value="deviceSelection">Device Selection</Option> */}
              <Option value="none">None</Option>
            </DashboardTheme>
          </Form.Item>

          {(DashboardLevelSelection === 'none') || (DashboardLevelSelection !== 'dateMonthYearPicker') ? (
            <Form.Item label="Time Bucket">
              <DashboardTheme
                onChange={(e) => setTimeBucket(e)}
                value={TimeBucket}
                disabled={TimeBucketKey}
              >
                <Select.Option value="1m">1 Minute (1m)</Select.Option>
                <Select.Option value="1h">1 Hour (1h)</Select.Option>
                <Select.Option value="1d">1 Day (1d)</Select.Option>
                <Select.Option value="1week">1 Week (1week)</Select.Option>
                <Select.Option value="1month">1 Month (1month)</Select.Option>
                <Select.Option value="1y">1 Year (1y)</Select.Option>
                <Select.Option value="none">None</Select.Option>
              </DashboardTheme>
            </Form.Item>
          ) : null}

          {DashboardLevelSelection === 'dateMonthYearPicker' && (
            <div>
              {inputFields && Object.keys(inputFields) &&
                Object.keys(inputFields).map((item, index) => (
                  <div key={item}>
                    <Form.Item label={item}>
                      <input
                        style={{ width: '150px' }}
                        type="text"
                        value={inputFields[item]}
                        onChange={(e) => handleInputChange(e, item)}
                      />
                      <MinusCircleOutlined
                        style={{ color: 'red', marginLeft: '20px' }}
                        onClick={() => handleRemoveFields(item)}
                      />
                      {index === 0 && (
                        <Tooltip title={'Add Other Selections'}>
                          <PlusOutlined
                            style={{ color: 'green', marginLeft: '20px' }}
                            onClick={resetTimeBucket}
                          />
                        </Tooltip>
                      )}
                    </Form.Item>
                  </div>
                ))}
            </div>
          )}

          {DashboardLevelSelection && DashboardLevelSelection !== 'none' && (
            <Form.Item label="Selection EndPoint">
              <DashboardTheme
                onChange={(e) => setDashboardLevelSelectionPoint(e)}
                value={DashboardLevelSelectionPoint}
              >
                <Select.Option value="PreviousDay">Previous Day</Select.Option>
                <Select.Option value="CurrentDay">Current Day</Select.Option>
              </DashboardTheme>
            </Form.Item>
          )}
          <Form.Item label="Device Selection">
            <Checkbox
              checked={deviceMultiSelect === 'true'}
              onChange={() => checkboxOnChange('true')}
            >
              True
            </Checkbox>
            <Checkbox
              checked={deviceMultiSelect === 'false'}
              onChange={() => checkboxOnChange('false')}
            >
              False
            </Checkbox>
          </Form.Item>

          {deviceMultiSelect === 'true' && (
            <Form.Item label="Device Selection Type">
              <Select
                style={{ width: '200px' }}
                value={hierarchyViewType || ''}
                placeholder={'Select Hierarchy ViewType'}
                onChange={(e) => {
                  setHierarchyViewType(e);
                }}
              >
                <Select.Option value="Tree Modal">Tree Modal</Select.Option> {/* Tree */}
                <Select.Option value="Tree Select">Tree Select</Select.Option> {/**Select Treee **/}
                <Select.Option value="Select">Select</Select.Option> {/** dynamic **/}
                <Select.Option value="Tree Drawer">Tree Drawer</Select.Option> {/** station **/}
              </Select>
              {deviceMultiSelect === 'true' && hierarchyViewType === "Select" ? (
                <div>
                  <Select
                    style={{ width: '200px' }}
                    value={apiPayload?.method}
                    placeholder={'Select Method'}
                    onChange={selectMethod}
                  >
                    <Select.Option value="GET">GET</Select.Option>
                    <Select.Option value="POST">POST</Select.Option>
                  </Select>

                  <Input
                    style={{ width: '300px' }}
                    value={apiPayload?.url || ''}
                    placeholder="Enter URL"
                    onChange={enterURL}
                  />

                  {apiPayload?.method === 'POST' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={
                        apiPayload?.payload && Object.keys(apiPayload.payload).length > 0
                          ? JSON.stringify(apiPayload.payload)
                          : ''
                      }
                      placeholder="Enter payload"
                      onBlur={selectPayload}
                    />
                  )}

                  {apiPayload?.method === 'GET' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={apiPayload?.GETParams || ''}
                      placeholder="Enter GETParams"
                      onBlur={selectGETParams}
                    />
                  )}
                </div>
              ) : null}
              {deviceMultiSelect === 'true' && hierarchyViewType === "Tree Select"
                || hierarchyViewType === "Tree Modal" ||
                hierarchyViewType === "Tree Drawer" ?
                <div>
                  <Select
                    style={{ width: '200px' }}
                    value={apiPayload?.method}
                    placeholder={'Select Method'}
                    onChange={selectMethod}
                  >
                    <Select.Option value="GET">GET</Select.Option>
                    <Select.Option value="POST">POST</Select.Option>
                  </Select>

                  <Input
                    style={{ width: '300px' }}
                    value={apiPayload?.url || ''}
                    placeholder="Enter URL"
                    onChange={enterURL}
                  />

                  {apiPayload?.method === 'POST' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={
                        apiPayload?.payload && Object.keys(apiPayload.payload).length > 0
                          ? JSON.stringify(apiPayload.payload)
                          : ''
                      }
                      placeholder="Enter payload"
                      onBlur={selectPayload}
                    />
                  )}

                  {apiPayload?.method === 'GET' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={apiPayload?.GETParams || ''}
                      placeholder="Enter GETParams"
                      onBlur={selectGETParams}
                    />
                  )}

                  {/* {apiPayload?.url === "GET" && apiPayload?.url === "POST" ? ( */}
                  <Select
                    style={{ width: '200px' }}
                    value={isMultiLevelDashboard || ''}
                    placeholder={'Select Is MultiLevel Dashboard ?'}
                    onChange={(value) => setIsMultiLevelDashboard(value)}
                  >
                    <Option value={'true'}>true</Option>
                    <Option value={'false'}>false</Option>
                  </Select>
                  {/* ) : null} */}
                  {isMultiLevelDashboard === 'true' && (
                    <Form
                      name="dynamic_form_nest_item"
                      initialValues={{ multiLevelSettings }}
                      onFinish={(values) => setMultiLevelSettings(values.multiLevelSettings)}
                      autoComplete="off"
                    >
                      <Form.List name="multiLevelSettings">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Space key={key} style={{ display: 'flex', marginBottom: 0 }} align="baseline">
                                <Form.Item
                                  {...restField}
                                  name={[name, 'LevelType']}
                                  rules={[{ required: true, message: 'Missing Level Type' }]}
                                >
                                  <Input placeholder="Level Type" />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'DashboardName']}
                                  rules={[{ required: true, message: 'Missing Dashboard Name' }]}
                                >
                                  <Input placeholder="Dashboard Name" />
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)} />
                              </Space>
                            ))}
                            <Form.Item>
                              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Add field
                              </Button>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Update configuration
                        </Button>
                      </Form.Item>
                    </Form>
                  )}
                </div>
                : null}
            </Form.Item>   
          )}
          <Form.Item label="Image Name">
            <Input value={imageName}
              onChange={onChangeimageName}
            />
          </Form.Item>
        </Form>
      </Modal>

      <div>{panels && Array.isArray(panels) && panels.length > 0 ? createPanels() : ''}</div>
      <ConfigurationModalContent
        DeviceData={props.DeviceData}
        AssetData={props.AssetData}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        editData={editData}
      />
      <DashboardLevelConfig />
    </EditDashboardDiv>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.getUserProfile,
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(NewDashboard);
